<section class="layout__main-modal participant-field-form-dialog">
  <div
    mat-dialog-title
    class="dialog-title"
  >
    Form Field
  </div>
  <mat-dialog-content class="dialog-content">
    <div
      *ngIf="form"
      class="form-field"
      [formGroup]="form"
    >
      <ng-container [ngSwitch]="property.controlType">
        <!-- Text Box -->
        <mat-form-field
          *ngSwitchCase="'textbox'"
          class="full-width"
        >
          <mat-label>{{ property.label }}</mat-label>
          <input
            matInput
            [formControlName]="property.key"
            [id]="property.key"
            [required]="property.required"
            [readonly]="property.readonly"
          />
          <mat-error *ngIf="form.controls[property.key].hasError('required'); else otherValidators"> This field is required</mat-error>
        </mat-form-field>
        <!-- End Text Box -->

        <!-- Number -->
        <mat-form-field
          *ngSwitchCase="'number'"
          class="full-width"
        >
          <mat-label>{{ property.label }}</mat-label>
          <input
            matInput
            [formControlName]="property.key"
            [id]="property.key"
            [required]="property.required"
            [readonly]="property.readonly"
          />
          <mat-error *ngIf="form.controls[property.key].hasError('required'); else otherValidators"> This field is required</mat-error>
        </mat-form-field>
        <!-- End Number -->

        <!-- Date -->
        <ng-container *ngSwitchCase="'date'">
          <!-- Short Date -->
          <mat-form-field
            *ngIf="property.type === 'shortDate'"
            class="full-width"
          >
            <mat-label>{{ property.label }}</mat-label>
            <input
              matInput
              [matDatepicker]="picker"
              type="text"
              [formControlName]="property.key"
              placeholder="Enter Date"
              (click)="picker.open()"
              readonly
              [required]="property.required"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>

          <!-- End Short Date -->

          <!-- Time -->
          <!-- <mat-form-field
            *ngIf="property.type === ''"
            class="full-width"
          >
            <mat-label>{{ property.label }}</mat-label>
            <input
              [ngxTimepicker]="timePicker"
              type="text"
              matInput
              [formControlName]="property.key"
              placeholder="Enter Time"
              readonly
              [required]="property.required"
            />
            <ngx-material-timepicker-toggle
              matSuffix
              [for]="timePicker"
            >
            </ngx-material-timepicker-toggle>
            <ngx-material-timepicker
              #timePicker
              [appendToInput]="true"
            >
            </ngx-material-timepicker>
          </mat-form-field> -->

          <mat-form-field
            *ngIf="property.type === 'time'"
            class="full-width"
          >
            <mat-label>{{ property.label }}</mat-label>
            <input
              #t="redTimepicker"
              redTimepicker
              placeholder="Enter Time"
              [formControlName]="property.key"
              [required]="property.required"
            />
            <mat-icon
              matSuffix
              (click)="t.showDialog()"
              >access_time</mat-icon
            >
          </mat-form-field>
          <!-- End Time -->
        </ng-container>
        <!-- End Date -->

        <!-- Dropdown -->
        <mat-form-field
          *ngSwitchCase="'dropdown'"
          class="full-width"
        >
          <mat-label>{{ property.label }}</mat-label>
          <mat-select
            disableRipple
            required
            [id]="property.key"
            [formControlName]="property.key"
          >
            <mat-option
              *ngFor="let opt of property.options"
              [value]="opt"
            >
              {{ opt }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls[property.key].hasError('required'); else otherValidators"> This field is required</mat-error>
        </mat-form-field>
        <!-- End Dropdown -->
      </ng-container>
      <ng-template #otherValidators>
        <mat-error *ngIf="form.controls[property.key].hasError('email')"> This email is not valid</mat-error>
        <mat-error *ngIf="form.controls[property.key].hasError('url')"> This url is not valid</mat-error>
      </ng-template>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button
      mat-flat-button
      (click)="close()"
    >
      Cancel
    </button>
    <button
      mat-button
      class="cimb-button--primary"
      (click)="submit()"
    >
      Save changes
    </button>
  </mat-dialog-actions>
</section>
